import React from 'react';
import Layout from '../utils/layout';
import PasswordForget from '../components/scenes/Auth/scenes/PasswordForget/PasswordForget';

export default () => (
  <Layout hideNav>
    <PasswordForget />
  </Layout>
);
